import * as yup from 'yup'
import 'yup-phone'

const newUserSchema = yup.object().shape({
  firstName: yup.string().required("Please specify the user's First Name"),
  lastName: yup.string().required("Please specify the user's Last Name"),
  email: yup
    .string()
    .email('Please enter a valid email address')
    .when('role', {
      is: (role: string) => role !== 'Passenger',
      then: yup.string().required('Please enter a valid email address'),
      otherwise: yup.string().notRequired(),
    }),
  role: yup.string().required("Please specify the user's role"),
  mobileNumber: yup
    .string()
    .trim()
    .label('Mobile Number')
    .required("Please specify the user's mobile number"),
})

const roleStrings = yup.string()

const updateUserSchema = yup.object().shape({
  firstName: yup.string().required("Please specify the user's First Name."),
  lastName: yup.string().required("Please specify the user's Last Name."),
  email: yup
    .string()
    .email('Please enter a valid email address')
    .when('roles', {
      is: (role: string) => role !== 'Passenger',
      then: yup.string().required("Please specify the user's email address"),
      otherwise: yup.string().notRequired(),
    }),
  roles: yup
    .array()
    .of(roleStrings)
    .required('Please select at least one role.'),
  mobileNumber: yup
    .string()
    .trim()
    .nullable()
    .label('Mobile Number')
    .when('roles', {
      is: (role: string) => role === 'Passenger',
      then: yup
        .string()
        .phone()
        .required('Please specify the users mobile number'),
      otherwise: yup.string().notRequired(),
    })
    .when({
      is: (val: any) => val.length > 6,
      then: yup.string().phone().label('Mobile number'),
    }),
})

export { newUserSchema, updateUserSchema }
